import React, {Component} from 'react';
import SearchBar from '../SearchBar/SearchBar'
import NavBar from '../NavBar/NavBar';

class Navigation extends Component {
	constructor(props) {
    	super(props);
    	this.state={
			section_open:false,
			filter_open:false
    	};
	}

	toggle=(type,toggle)=>{
		let open=(toggle!==undefined?toggle:this.state[type]===false);
		if(open!==this.state[type])
			this.setState({
				section_open:false,
				filter_open:false,
				[type]:open
			});
	}
	
	render(){
		return (
			<React.Fragment>
				<NavBar toggle_sections={(toggle)=>this.toggle('section_open',toggle)} section_open={this.state.section_open} toggle_filters={(toggle)=>this.toggle('filter_open',toggle)}/>
          		<SearchBar toggle_region={this.props.toggle_region} toggle_filters={(toggle)=>this.toggle('filter_open',toggle)} filter_open={this.state.filter_open}/>
			</React.Fragment>
		);
	}
}

export default Navigation;